import { useState } from 'react';

export default function MobileView({ categories, selectedCategory, onSelectCategory, view, setView }) {
    const [searchQuery, setSearchQuery] = useState('');

    const handleShare = () => {
        const tweet = encodeURIComponent(`local food spots to your weekend date plans.\n\neverything you need to know about delhi. \n \ncheck out: https://dilli.wiki`);
        const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${tweet}`;
        window.open(twitterIntentUrl, '_blank');
    };

    // Filter categories based on search
    const filteredCategories = categories.filter(cat => 
        cat.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (cat.places && cat.places.some(place => 
            place.name.toLowerCase().includes(searchQuery.toLowerCase())
        ))
    );

    // Format date for display
    const formatDate = () => {
        const now = new Date();
        const diffDays = 0; // Today
        if (diffDays === 0) return 'Today';
        if (diffDays === 1) return 'Yesterday';
        return now.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    // Get preview text for a category
    const getPreviewText = (category) => {
        if (!category.places || category.places.length === 0) {
            return 'No places yet';
        }
        const firstPlace = category.places[0];
        return `${firstPlace.name}${category.places.length > 1 ? `, ${category.places.length - 1} more...` : ''}`;
    };

    // Notes list view (default)
    if (view === 'notes') {
        return (
            <div className="w-full h-full bg-[#1C1C1E] flex flex-col md:hidden overflow-hidden">
                {/* Header */}
                <div className="pt-safe-top bg-[#1C1C1E]">
                    <div className="h-14 px-4 flex items-center justify-between">
                        <span className="text-[20px] font-bold text-white">dilli.wiki</span>
                        <i 
                            className="ph ph-export text-[#FFB400] text-xl cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={handleShare}
                        ></i>
                    </div>
                </div>

                {/* Search */}
                <div className="px-4 pb-3 bg-[#1C1C1E]">
                    <div className="bg-[#2C2C2E] h-9 rounded-[8px] flex items-center px-2 gap-2 text-[#8E8E93] focus-within:text-[#EBEBF5] focus-within:bg-[#3A3A3C] transition-colors">
                        <i className="ph ph-magnifying-glass text-lg"></i>
                        <input 
                            type="text" 
                            placeholder="Search" 
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="bg-transparent border-none outline-none text-[15px] placeholder-[#8E8E93] w-full text-white/90"
                        />
                        {searchQuery && (
                            <i 
                                className="ph ph-x text-lg cursor-pointer hover:text-white"
                                onClick={() => setSearchQuery('')}
                            ></i>
                        )}
                    </div>
                </div>

                {/* Notes List */}
                <div className="flex-1 overflow-y-auto bg-[#1C1C1E]">
                    {/* Pinned Section */}
                    <div className="px-5 py-1.5 text-[11px] font-semibold text-[#8E8E93] bg-[#1C1C1E] sticky top-0 uppercase tracking-wider backdrop-blur-sm bg-opacity-90 z-10">
                        Pinned
                    </div>
                    
                    {/* Start Here pinned note */}
                    <div
                        onClick={() => {
                            onSelectCategory({ id: 'start-here', name: 'Start Here', isStartHere: true });
                            setView('note');
                        }}
                        className={`mx-3 mb-1 p-4 rounded-[10px] cursor-pointer relative group transition-all ${
                            selectedCategory?.id === 'start-here'
                                ? 'bg-[#C69C08]/20 border border-[#FFB400]/20' 
                                : 'bg-[#2C2C2E] border border-transparent hover:border-[#FFB400]/30'
                        }`}
                    >
                        <div className="flex justify-between items-start mb-0.5">
                            <h3 className="font-bold text-[15px] text-white truncate pr-2">Start Here</h3>
                            <i className="ph ph-push-pin-simple text-[#8E8E93] text-sm transform -rotate-45"></i>
                        </div>
                        <div className="flex gap-2 text-[14px]">
                            <span className="text-[#EBEBF5]/90 line-clamp-2 leading-snug">
                                Want to romanticise Delhi on Instagram? From cholle bhature to cafes to hidden spots, I've got your weekend plans sorted.
                            </span>
                        </div>
                        <div className="mt-2 text-[13px] text-[#8E8E93]">10:42 AM</div>
                    </div>

                    {/* Notes Section */}
                    <div className="px-5 py-1.5 mt-2 text-[11px] font-semibold text-[#8E8E93] bg-[#1C1C1E] sticky top-0 uppercase tracking-wider backdrop-blur-sm bg-opacity-90 z-10">
                        Notes
                    </div>

                    {filteredCategories.map((category) => {
                        const isSelected = selectedCategory?.id === category.id;
                        return (
                            <div
                                key={category.id}
                                onClick={() => {
                                    onSelectCategory(category);
                                    setView('note');
                                }}
                                className={`mx-3 mb-1 p-4 rounded-[10px] cursor-pointer relative group transition-all ${
                                    isSelected 
                                        ? 'bg-[#C69C08]/20 border border-[#FFB400]/20' 
                                        : 'hover:bg-[#2C2C2E] border-b border-[#38383A] last:border-0'
                                }`}
                            >
                                <h3 className="font-bold text-[15px] text-white mb-0.5">
                                    {category.emoji && <span className="mr-2">{category.emoji}</span>}
                                    {category.name}
                                </h3>
                                <div className="flex gap-2 text-[14px]">
                                    <span className="text-[#8E8E93] whitespace-nowrap">
                                        {formatDate()}
                                    </span>
                                    <span className="text-[#8E8E93] line-clamp-2 leading-snug">
                                        {getPreviewText(category)}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Footer */}
                <div className="h-10 border-t border-black/50 flex items-center justify-center text-[11px] text-[#8E8E93] bg-[#1C1C1E]">
                    9 Notes
                </div>
            </div>
        );
    }

    // Note detail view
    if (selectedCategory?.isStartHere) {
        return (
            <div className="w-full h-full bg-[#141414] flex flex-col md:hidden overflow-hidden">
                {/* Header */}
                <div className="pt-safe-top bg-[#141414] border-b border-[#38383A]/50">
                    <div className="h-14 px-4 flex items-center justify-between">
                        <button 
                            onClick={() => setView('notes')}
                            className="text-[#FFB400] text-[17px] font-medium -ml-1"
                        >
                            <i className="ph ph-caret-left text-xl mr-1"></i>
                            dilli.wiki
                        </button>
                        <div className="flex items-center gap-4">
                            <i 
                                className="ph ph-export text-[#FFB400] text-xl cursor-pointer hover:opacity-80 transition-opacity"
                                onClick={handleShare}
                            ></i>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto px-4 py-6 note-content">
                    <h1 className="text-[28px] font-bold text-white mb-6 leading-tight">Want to romanticise Delhi on Instagram?</h1>
                    <div className="text-[17px] text-[#EBEBF5] leading-[1.6]">
                        <p>
                            From cholle bhature to cafes to hidden spots, I've got your weekend plans sorted. This is a local's guide to falling in love with Delhi.
                        </p>
                        <div className="flex items-start gap-3 my-4">
                            <div className="w-6 h-6 bg-[#FFB400] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                <i className="ph ph-check text-black text-sm font-bold"></i>
                            </div>
                            <p className="text-[17px] text-[#EBEBF5]">
                                Stop getting lost on Google Maps. This city is not for beginners.
                            </p>
                        </div>
                        <div className="w-full max-w-sm overflow-hidden border border-black/10 my-6">
                            <img 
                                src="/header.png" 
                                alt="Delhi skyline" 
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full h-full bg-[#141414] flex flex-col md:hidden overflow-hidden">
            {/* Header */}
            <div className="pt-safe-top bg-[#141414] border-b border-[#38383A]/50">
                <div className="h-14 px-4 flex items-center justify-between">
                    <button 
                        onClick={() => setView('notes')}
                        className="text-[#FFB400] text-[17px] font-medium -ml-1"
                    >
                        <i className="ph ph-caret-left text-xl mr-1"></i>
                        dilli.wiki
                    </button>
                    <div className="flex items-center gap-4">
                        <i 
                            className="ph ph-export text-[#FFB400] text-xl cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={handleShare}
                        ></i>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-4 py-6 note-content">
                {selectedCategory && (
                    <>
                        <h1 className="text-[28px] font-bold text-white mb-6 leading-tight">
                            {selectedCategory.emoji && <span className="mr-2">{selectedCategory.emoji}</span>}
                            {selectedCategory.name}
                        </h1>
                        <div className="text-[17px] text-[#EBEBF5] leading-[1.6] space-y-6">
                            {selectedCategory.places && selectedCategory.places.length > 0 ? (
                                <>
                                    {selectedCategory.places.map((place, index) => (
                                    <div key={place.id || index} className="flex gap-4 group">
                                        <span className="text-[#EBEBF5] mt-0.5">{index + 1}.</span>
                                        <div className="flex-1 border-b border-[#38383A] pb-4 last:border-0">
                                            <a 
                                                href={place.href} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="font-semibold text-[#FFB400] underline decoration-[#FFB400]/30 hover:decoration-[#FFB400] underline-offset-4 transition-all"
                                            >
                                                {place.name}
                                            </a>
                                        </div>
                                    </div>
                                    ))}
                                </>
                            ) : (
                                <p className="text-[#8E8E93]">No places added yet.</p>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
